// Routes.js
import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import BaseLayout from './components/Layouts/BaseLayout';
import WebBaseLayout from './components/weblayouts/WebBaseLayout';
import HomePage from './Pages/WebPage/Home';
import DashboardPage from './Pages/Member/Dashboard';
import AssociationDashboardPage from './Pages/Member/AssociationDetails/Dashboard';
import LoginPage from './Pages/Member/Auth/Login';
import RegisterPage from './Pages/Member/Auth/Register';
import ForgotPasswordPage from './Pages/Member/Auth/ForgotPassword';
import PasswordChangePage from './Pages/Member/Auth/ChangePassword';
import MemberProfilePage from './Pages/Member/Profile';
import MemberAccountPage from './Pages/Member/Account';
import MyApplicationsPage from './Pages/Member/MyApplications';
import MyInvitationsPage from './Pages/Member/MyInvitations';
import OpenAssociationsPage from './Pages/Member/OpenAssociations';
import MyAssociationsPage from './Pages/Member/MyAssociations';
import MembershipPage from './Pages/Member/AssociationDetails/Membership';
import ForumPage from './Pages/Member/AssociationDetails/Forum';
import AssociationEventsPage from './Pages/Member/AssociationDetails/Events';
import AssociationMeetingsPage from './Pages/Member/AssociationDetails/Meetings';
import AssociationNewsPage from './Pages/Member/AssociationDetails/News';
import AssociationAdminDashboardPage from './Pages/AssociationAdmin/Dashboard';
import AssociationAdminProfilePage from './Pages/AssociationAdmin/Profile';
import MembersListPage from './Pages/AssociationAdmin/Members';
import AssociationAdminApplicationsPage from './Pages/AssociationAdmin/Applications';
import MeetingsListPage from './Pages/AssociationAdmin/Meetings';
import AssociationAdminForumPage from './Pages/AssociationAdmin/Forum';
import AssociationAdminNewsPage from './Pages/AssociationAdmin/News';
import VerifyEmailPage from './Pages/Member/Auth/VerifyEmail';
import EmailVerifiedPage from './Pages/Member/Auth/EmailVerified';
import VerifyAssociationEmailPage from './Pages/AssociationAdmin/Auth/VerifyEmail';
import AssociationEmailVerifiedPage from './Pages/AssociationAdmin/Auth/EmailVerified';
import AssociationLoginPage from './Pages/AssociationAdmin/Auth/Login';
import AssociationForgotPasswordPage from './Pages/AssociationAdmin/Auth/ForgotPassword';
import AssociationPasswordChangePage from './Pages/AssociationAdmin/Auth/ChangePassword';
import AssociationAdminAccountPage from './Pages/AssociationAdmin/Account';
import useAuth from './hooks/useAuthContext';
import AssociationInfoLayout from './components/Layouts/AssociationInfoLayout';
import AssociationAdminDuesPage from './Pages/AssociationAdmin/Dues/Dues';
import ManageMemberDuesPage from './Pages/AssociationAdmin/Dues/ManageMember';
import MemberDuesPage from './Pages/Member/AssociationDetails/MemberDues';
import SuperAdminLoginPage from './Pages/Admin/Auth/Login';
import SuperAdminDashboardPage from './Pages/Admin/Dashboard';

const AppRoutes = () => {
    const {userData}  = useAuth()

  return (
    <Routes>
        <Route path="/">
            {/* <Route index element={<Navigate to="/home" />} /> */}
            <Route index element={<WebBaseLayout><HomePage/></WebBaseLayout>} />
            <Route path="auth">
                <Route path="login" element={<LoginPage />} />
                <Route path="register" element={<RegisterPage />} />
                <Route path="forgot-password" element={<ForgotPasswordPage />} />
                <Route path="reset-password" element={<PasswordChangePage />} />
                <Route path="verify-email" element={<VerifyEmailPage />} />
                <Route path="email-verified" element={<EmailVerifiedPage />} />

                <Route path='association'>
                    <Route path="login" element={<AssociationLoginPage />} />
                    <Route path='verify-email' element={<VerifyAssociationEmailPage />} />
                    <Route path='email-verified' element={<AssociationEmailVerifiedPage />} />
                    <Route path="forgot-password" element={<AssociationForgotPasswordPage />} />
                    <Route path="reset-password" element={<AssociationPasswordChangePage />} />
                </Route>

                <Route path='admin'>
                    <Route path="login" element={<SuperAdminLoginPage />} />
                    {/* <Route path='verify-email' element={<VerifyAssociationEmailPage />} />
                    <Route path='email-verified' element={<AssociationEmailVerifiedPage />} />
                    <Route path="forgot-password" element={<AssociationForgotPasswordPage />} />
                    <Route path="reset-password" element={<AssociationPasswordChangePage />} /> */}
                </Route>
            </Route>
            <Route path="app">
                <Route path="dashboard" element={userData && userData.userInfo ? <BaseLayout><DashboardPage /></BaseLayout> :  <Navigate to="/auth/login" />} />
                <Route path="profile" element={<BaseLayout><MemberProfilePage /></BaseLayout>} />
                <Route path="applications" element={<BaseLayout><MyApplicationsPage /></BaseLayout>} />
                <Route path="invitations/:invitationId?" element={userData && userData.userInfo ? <BaseLayout><MyInvitationsPage /></BaseLayout> :  <Navigate to="/auth/login" />} />
                <Route path="open_associations" element={<BaseLayout><OpenAssociationsPage /></BaseLayout>} />
                <Route path="account" element={<BaseLayout><MemberAccountPage /></BaseLayout>} />
                <Route path="associations">
                    <Route path="" element={<BaseLayout><MyAssociationsPage /></BaseLayout>} />
                    {/* AssociationDashboardPage */}
                    <Route path=":associationId" element={<AssociationInfoLayout><AssociationDashboardPage /></AssociationInfoLayout>} />
                    <Route path=":associationId/membership" element={<AssociationInfoLayout><MembershipPage /></AssociationInfoLayout>} />
                    <Route path=":associationId/forum" element={<AssociationInfoLayout><ForumPage /></AssociationInfoLayout>} />
                    <Route path=":associationId/events" element={<AssociationInfoLayout><AssociationEventsPage /></AssociationInfoLayout>} />
                    <Route path=":associationId/meetings" element={<AssociationInfoLayout><AssociationMeetingsPage /></AssociationInfoLayout>} />
                    <Route path=":associationId/news" element={<AssociationInfoLayout><AssociationNewsPage /></AssociationInfoLayout>} />
                    <Route path=":associationId/dues" element={userData && userData.userInfo ?<AssociationInfoLayout><MemberDuesPage /></AssociationInfoLayout>:  <Navigate to="/auth/login" />} />

                    <Route path="admin">
                        <Route path="" element={<BaseLayout><AssociationAdminDashboardPage /></BaseLayout>} />
                        <Route path="profile" element={<BaseLayout><AssociationAdminProfilePage /></BaseLayout>} />
                        <Route path="account" element={<BaseLayout><AssociationAdminAccountPage /></BaseLayout>} />
                        <Route path="members" element={<BaseLayout><MembersListPage/></BaseLayout>} />
                        <Route path="applications" element={<BaseLayout><AssociationAdminApplicationsPage/></BaseLayout>} />
                        <Route path="dues" element={<BaseLayout><AssociationAdminDuesPage/></BaseLayout>} />
                        <Route path="dues/attach/:memberId" element={<BaseLayout><ManageMemberDuesPage/></BaseLayout>} />
                        <Route path="meetings" element={<BaseLayout><MeetingsListPage/></BaseLayout>} />
                        <Route path="forum" element={<BaseLayout><AssociationAdminForumPage/></BaseLayout>} />
                        <Route path="news" element={<BaseLayout><AssociationAdminNewsPage/></BaseLayout>} />
                    </Route>
                </Route>
                <Route path="admin">
                    <Route path="dashboard" element={userData && userData.userInfo ? <BaseLayout><SuperAdminDashboardPage /></BaseLayout> :  <Navigate to="/auth/admin/login" />} />
                </Route>
            </Route>
            {/* <Route path="home" element={<WebBaseLayout><HomePage/></WebBaseLayout>} /> */}
        </Route>
    </Routes>
  );
};

export default AppRoutes;
